import React, { useEffect, useRef, useState } from 'react';
import _ from 'lodash';
import { Input } from 'antd';
// import '@style/components/textArray.scss';
import '../styles/components/textArray.scss';
import { deleteConfirm } from '@components/dragableTableFrom/formItems';

const { TextArea } = Input;

function TextArray(props) {
  const { id } = props.value;
  const { formData } = props.config;
  const { maxLength } = props;
  const [descriptionData, setDescriptionData] = useState(props.value.data);

  function updateFormData(newDescription) {
    const matchedFormIndex = formData.findIndex((e) => e.id === id);
    formData[matchedFormIndex].activities = {
      data: newDescription,
      id,
    };
  }

  function handleChange(i, e) {
    const newDescription = JSON.parse(JSON.stringify(descriptionData));
    newDescription[i] = e.target.value;

    updateFormData(newDescription);
    setDescriptionData(newDescription);
  }

  function deleteRow() {
    props.onRowDelete(props.rowIndex);
  }

  function handleDelete(i, e) {
    const newDescription = _.filter(descriptionData, function (each) {
      return each !== e;
    });
    if (newDescription.length === 0) {
      deleteConfirm({ onOk: deleteRow });
    } else {
      updateFormData(newDescription);
      setDescriptionData(newDescription);
    }
  }

  function handleAddNew() {
    setDescriptionData([...descriptionData, '']);
  }

  return (
    <div>
      {descriptionData.map((e, i) => (
        <div className="textArray_entry">
          <TextArrayItem
            value={e}
            index={i}
            maxLength={maxLength}
            id={id}
            handleChange={handleChange}
          />
          <span
            className="appkiticon icon-circle-delete-fill"
            onClick={() => handleDelete(i, e)}
          />
        </div>
      ))}
      <div onClick={handleAddNew} className="textArray_add">
        + Add Description
      </div>
    </div>
  );
}

function TextArrayItem({ value, index, id, maxLength, handleChange }) {
  const activeId = `operatingModel-${id}-${index}`;
  const [showTextArea, setShowTextArea] = useState(false);
  const inputRef = useRef(null);

  const setCaretPositionEnd = (elementId) => {
    const element = document.getElementById(elementId);
    const pos = element?.value?.length || 0;
    element.setSelectionRange(pos, pos);
  };

  useEffect(() => {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
      setCaretPositionEnd(activeId);
    }
  }, [showTextArea]);
  return showTextArea ? (
    <TextArea
      value={value}
      maxLength={maxLength}
      id={activeId}
      ref={inputRef}
      autoSize
      onChange={(e) => handleChange(index, e)}
      onBlur={() => {
        setShowTextArea(false);
      }}
    />
  ) : (
    <Input
      value={value}
      onClick={() => {
        setShowTextArea(true);
      }}
    />
  );
}

export default TextArray;
